import type { LngLat } from "../adapters/types";

const CIRCLE_RING_SEGMENTS = 64;

/**
 * Anneau fermé approximant le cercle `[centre, point de bord]`, qui part de son point de bord : une
 * position le long de l'anneau (une ouverture) tourne ainsi avec le cercle.
 */
export function circleRing([center, edge]: [LngLat, LngLat]): LngLat[] {
  const [centerLng, centerLat] = center;
  const [edgeLng, edgeLat] = edge;
  const metersPerDegLat = 111_320;
  const metersPerDegLng = 111_320 * Math.cos((centerLat * Math.PI) / 180);
  const dx = (edgeLng - centerLng) * metersPerDegLng;
  const dy = (edgeLat - centerLat) * metersPerDegLat;
  const radiusMeters = Math.hypot(dx, dy);
  const startAngle = Math.atan2(dy, dx);

  const ring: LngLat[] = [];
  for (let i = 0; i < CIRCLE_RING_SEGMENTS; i++) {
    const angle = startAngle + (2 * Math.PI * i) / CIRCLE_RING_SEGMENTS;
    ring.push([
      centerLng + (radiusMeters * Math.cos(angle)) / metersPerDegLng,
      centerLat + (radiusMeters * Math.sin(angle)) / metersPerDegLat,
    ]);
  }
  ring.push(ring[0]!);
  return ring;
}
